import { useMemo } from 'react';

import { useDiscountWizardStateContext } from '../state';
import { useDetailsStepData } from '../steps/details/use-details-data';

export function useSelectedDetailsResources() {
  const { customerTypesOptions, discountGroupOptions, locationOptions, segmentOptions, orderSourceOptions } =
    useDetailsStepData();
  const {
    detailsStepState: { availableLocIds, customerTypeIds, discountGroupIds, segmentIds, platformTypeRestrictions },
  } = useDiscountWizardStateContext();

  const selectedCustomerTypes = useMemo(
    () =>
      customerTypesOptions
        .filter((option) => customerTypeIds.includes(Number(option.value)))
        .map((option) => option.label),
    [customerTypeIds, customerTypesOptions]
  );

  const selectedCustomerGroups = useMemo(
    () =>
      discountGroupOptions
        .filter((option) => discountGroupIds.includes(Number(option.value)))
        .map((option) => option.label),
    [discountGroupIds, discountGroupOptions]
  );

  const selectedLocations = useMemo(
    () =>
      locationOptions.filter((option) => availableLocIds.includes(Number(option.value))).map((option) => option.label),
    [availableLocIds, locationOptions]
  );

  const selectedCustomerSegments = useMemo(
    () => segmentOptions.filter((option) => segmentIds.includes(Number(option.value))).map((option) => option.label),
    [segmentIds, segmentOptions]
  );

  const orderSourceIds = useMemo(
    () => platformTypeRestrictions.map((restriction) => restriction.PlatformTypeId),
    [platformTypeRestrictions]
  );
  const selectedOrderSources = useMemo(
    () =>
      orderSourceOptions
        .filter((option) => orderSourceIds.includes(Number(option.value)))
        .map((option) => option.label),
    [orderSourceIds, orderSourceOptions]
  );

  return {
    selectedCustomerTypes,
    selectedCustomerGroups,
    selectedLocations,
    selectedCustomerSegments,
    selectedOrderSources,
  };
}
